module.exports = __webpack_public_path__ + "img/illustrator.d29d36c5.svg";